import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, throwError } from "rxjs";
import { AuthService } from "./services/auth.service";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  // allow the request send http-only-cookie
  const authReq = req.clone({
    withCredentials: true,
  });

  // auto logout when unauthorized/forbidden/gone
  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if ([401, 403, 410].includes(error.status)) {
        authService.cleanUpState();
      }
      return throwError(() => error);
    })
  );
};
